import state from './meetingNoteState'
import mutations from './meetingNoteMutations'
import getters from './meetingNoteGetters'
import actions from './meetingNoteActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
